<template>
  <div>
    <Modal v-model="userForm" :title="title" width="600" :mask-closable="false">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="110">
       
        <Row>
            <Col span="24">
                <FormItem label="IP地址" prop="ip" :class="{requireStar:true}" >
                  <Input v-model="formValidate.ip"  ></Input>
                </FormItem>
            </Col>
        </Row>
       
         <Row>
            <Col span="24">
                <FormItem label="用户名" prop="username" :class="{requireStar:true}" >
                  <Input v-model="formValidate.username"  ></Input>
                </FormItem>
            </Col>
        </Row>
      
      </Form>
      <!--自定义按钮，解决自带按钮，点击就关闭的问题-->
      <div slot="footer">
        <Button type="text" size="large" @click="cancle">取消</Button>
        <Button type="primary" size="large" @click="handleSubmit('formValidate')">确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import Bus from '@/utils/bus.js'
  export default {
    components:{
    },
    data() {
      
      
      return {
        userForm: false,
        title:'',
        formValidate: {
          _id: '',
          username: '',
          ip: '',
          
        },
        ruleValidate: {
          username: [{
            required: true,
            message: '用户名不能为空',
            trigger: 'change'
          }],
          ip: [
            {
            required: true, message: 'IP地址不能为空',trigger: 'change'
            },
             {
                trigger: 'blur',
                 validator: (rule, value, callback) => {
                  var reg = /^((2[0-4]\d|25[0-5]|[01]?\d\d?)\.){3}(2[0-4]\d|25[0-5]|[01]?\d\d?)$/;
                  if (!reg.test(value)) {
                    callback(new Error('请输入正确的IP地址!'))
                  }
                  else{
                    callback()
                  }
                  } 
            },
            ],
         
        },
      }
    },

    methods: {
      openModal(title,row) {
        this.title =title
        this.userForm = true
        this.handleReset("formValidate");
         if(row!=null){
           this.formValidate=row
         }
      },
      
    
      
      handleSubmit(name) {
        this.$refs[name].validate((valid) => {
          if (valid) {
            let url =  '/api/safeIP' //"/province/sys/user/save";
            let myData = {
              _id: this.formValidate._id,
              ip: this.formValidate.ip,
              username: this.formValidate.username,
              type: 1,
              
            }
            this.req({
              url: url,
              method: 'post',
              data: myData
            }).then(response => {
              if (response.status == 200) {
                this.$Message.success('保存成功!');
                this.$parent.loadPage();
              } else {
                this.$Message.error('服务器错误:' + response.status);
              }
              this.userForm = false;
            }).catch(error => {
              this.reponseData = "发生错误，无法显示内容"
            })
          } else {
            return;
          }
        }) 
      },
      handleReset(name) {
         if (this.$refs[name]!==undefined) {
              this.$refs[name].resetFields();
          }
      },
      cancle() {
        this.userForm = false;
      },
    
    },
    mounted() {
    },
  }
</script>
<style>
  /*动态必填项className*/
  .requireStar .ivu-form-item-label:before{
    content: '*';
    display: inline-block;
    margin-right: 4px;
    line-height: 1;
    font-family: SimSun;
    font-size: 12px;
    color: #ed4014;
  }
</style>


// WEBPACK FOOTER //
// src/pages/platform/security/IPEdit.vue